import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent } from 'ui-component/src/public-api';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  providers: [DialogService],
  imports: [CommonModule, FormsModule, ButtonComponent],
})
export class ConfirmationDialogComponent {
  title = '';
  body = '';
  closeText = 'Close';
  confirmText = 'Confirm';
  isDoNothing = false;
  illustration?: string;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {
    this.title = this.dialogConfig.data?.title;
    this.body = this.dialogConfig.data?.message;
    this.closeText = this.dialogConfig.data?.closeText ?? 'Close';
    this.confirmText = this.dialogConfig.data?.confirmText ?? 'Confirm';
    this.isDoNothing = this.dialogConfig.data?.isDoNothing;
    this.illustration = this.dialogConfig.data?.illustration;
  }

  close() {
    this.ref.close();
  }

  confirm() {
    if (!this.isDoNothing) {
      this.ref.close(true);
    }
  }
}
